export default __webpack_public_path__ + "static/media/cinnamonroll.098a3adc.png";